module.exports = __webpack_public_path__ + "img/time-sand.2552d604.svg";